import React from 'react';
import { connect } from 'react-redux'
import { fetchEvent, returnFromEventDetails, clearEventPageState } from '../../actions'
import { Item,Segment, Divider} from 'semantic-ui-react'
import ReactGA from 'react-ga';
import { GA_TRACKING_EVENT_DETAILS_PAGE } from '../helpers/AppConsts'
import Footer from '../footer/Footer';

class EventPage extends React.Component {

  componentDidMount(){
    ReactGA.ga('send', 'pageview', GA_TRACKING_EVENT_DETAILS_PAGE);
    this.props.fetchEvent(this.props.match.params.eventId, this.props.match.params.event_organizer);
  }

  componentWillUnmount(){
    this.props.clearEventPageState();
  }

  onReturn = (formValues) => {
    this.props.returnFromEventDetails();
  }

  renderImage = () => {
    if(this.props.eventDetail.editEvent.event_img === 'available after competition'){
      return <img alt={this.props.eventDetail.editEvent.event_name} src="/images/wireframe/black-logo.png" className="ui fluid massive image centered" /> 
    }
    else{
      return <img alt={this.props.eventDetail.editEvent.event_name} src={this.props.eventDetail.editEvent.event_img} className="ui fluid massive image centered" />
    }
  }

  renderEvent() {

    return  (
              <div className="content">
                <Divider hidden/>
                {this.renderImage()}
            	<Segment centered>
                <Item centered>
                    <Item.Content >
                        <Item.Header as='h2'>{this.props.eventDetail.editEvent.event_name} </Item.Header>
                        <Item.Meta>{this.props.eventDetail.editEvent.event_location} </Item.Meta>
                        <Item.Description>
                        {this.props.eventDetail.editEvent.event_date} 
                        </Item.Description>
                        <Item.Extra>{this.props.eventDetail.editEvent.event_description} </Item.Extra>
                    </Item.Content>
                    </Item>
                </Segment>

              
                <button className="ui button positive" onClick={this.onReturn}>
                  Return
                </button>
               </div>
            )
            }


  render () {

    if(!this.props.eventDetail.editEvent){
      return (
          <React.Fragment>
            <div className="ui container">
              <h2>Game Details</h2>
              Loading..          
            </div>
            <Footer/>
          </React.Fragment>
      );
    }
    else {
      return (
        <React.Fragment>
          <div className="ui container">
            
            <div className="ui celled list">
            {this.renderEvent()}        
            </div>
          </div>
          <Footer/>

        </React.Fragment>
    
        );   
    }
    
    //
   
      }
};

const mapStateToProps = (state, ownProps) => {
  console.log("details", state.edits)
  return {
    eventDetail: state.edits,
    currentUserEmail: state.auth.userEmail
  };  
}

export default connect(mapStateToProps, {fetchEvent,returnFromEventDetails, clearEventPageState})(EventPage)
